import { useEffect, useState } from "react";
import { useStoreActions } from "ezStore";
import { Box, Typography, LinearProgress, Fade } from "@mui/material";
import { Language } from "imports/Utils";
import delay from "lodash.delay";
import img from "./img/cofano_logo_500.png";
import barge from "./img/barge.png";

const UpdateScreen = ({ version }: { version: string }) => {
	const { setVersion } = useStoreActions((store) => store.session);

	const [ progress, setProgress ] = useState(0);
	const [ messageIndex, setMessageIndex ] = useState(0);

	const messages = [
		Language("UPDATE_MESSAGE_1"),
		Language("UPDATE_MESSAGE_2"),
		Language("UPDATE_MESSAGE_3"),
	];

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 90) {
					return prev;
				}
				const increment = Math.floor(Math.random() * 15) + 5;
				return Math.min(prev + increment, 92);
			});
		}, 800);

		const textTimeout = setTimeout(() => {
			setMessageIndex(1);
		}, 2200);

		const finalTimeout = setTimeout(() => {
			clearInterval(interval);
			clearTimeout(textTimeout);

			setProgress(100);
			setMessageIndex(2);
			setVersion(version);

			delay(() => {
				window.location.reload();
			}, 1200);
		}, 5000);

		return () => {
			clearInterval(interval);
			clearTimeout(textTimeout);
			clearTimeout(finalTimeout);
		};
	}, [ version, setVersion ]);

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: "background.paper",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				p: 3,
				minHeight: "100vh",
				width: "100vw",
			}}>
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
					flexDirection: "column",
					maxWidth: 450,
					textAlign: "center",
					width: "100%",
				}}>
				<Fade in timeout={1000}>
					<Box
						component="img"
						src={img}
						alt="Cofano Logo"
						sx={{
							width: 220,
							height: "auto",
							mb: 6,
						}} />
				</Fade>

				<Box sx={{ width: "100%", position: "relative", mb: 4, pt: 4 }}>
					<Box
						component="img"
						src={barge}
						alt="Barge"
						sx={{
							bottom: 12,
							height: 32,
							left: `${progress}%`,
							position: "absolute",
							transform: "translateX(-50%)",
							transition: "left 0.8s ease-in-out",
						}} />

					<LinearProgress
						variant="determinate"
						value={progress}
						sx={{
							backgroundColor: "#e0e0e0",
							borderRadius: 4,
							height: 8,
						}} />
				</Box>

				<Box sx={{ height: 40, display: "flex", alignItems: "center", justifyContent: "center" }}>
					{messages.map((msg, idx) => (
						<Fade
							key={idx}
							in={messageIndex === idx}
							mountOnEnter
							unmountOnExit
							timeout={{ enter: 500, exit: 300 }}>
							<Typography
								variant="body1"
								sx={{
									color: "text.secondary",
									fontWeight: 500,
									position: messageIndex === idx ? "static" : "absolute",
								}}>
								{msg}
							</Typography>
						</Fade>
					))}
				</Box>

				<Typography variant="caption" sx={{ mt: 4, color: "text.disabled" }}>
                    Updating to v{version}
				</Typography>
			</Box>
		</Box>
	);
};

export default UpdateScreen;
